import { html, ref, repeat } from "@microsoft/fast-element";
import { FluentButton } from "@fluentui/web-components";
import { MsftFeedNavigationItem } from "../feed-navigation-item";
import { endTemplate } from "@microsoft/fast-foundation";
import { horizontalThreeDots } from "../svg";
// prevent tree shaking
MsftFeedNavigationItem;
FluentButton;
const overflowButtonId = "overflow-menu-button";
const navItemTemplate = html `
    <li part="list-item" role="none" class="${x => x.showPipeSeparator && "pipe"}">
        <msft-feed-navigation-item
            id="${x => x.id}"
            href="${x => x.href}"
            role="none"
            active=${(x, c) => x.id === c.parent.activeId || null}
            @click="${(x, c) => c.parent.onNavItemClick(x)}"
            @keypress="${(x, c) => c.parent.onNavItemKeyPress(c.event, x)}"
        >
            ${x => x.display}
        </msft-feed-navigation-item>
    </li>
`;
const overflowButton = html `
    <fluent-button
        type="button"
        id="${overflowButtonId}"
        appearance="stealth"
        aria-label="${x => x.localizedStrings.overflowButtonTooltip || null}"
        title="${x => x.localizedStrings.overflowButtonTooltip || null}"
        aria-haspopup="true"
        aria-expanded="${x => (x.showMenu ? "true" : null)}"
        @click=${(x, c) => x.toggleOverflowMenu(c.event)}
    >
        ${horizontalThreeDots}
    </fluent-button>
`;
const overflowTemplate = html `
    <div class=${x => x.isOverflowing ? "overflowContainer" : "overflowContainer hidden"}>
        ${overflowButton}
        <ul 
            class=${x => (x.showMenu ? "overflowMenu" : "hidden")}
            role="menu"
            aria-labelledby="${overflowButtonId}"
        >
            ${repeat(x => x.overflowItems, navItemTemplate)}
        </ul>
    </div?
`;
export const FeedNavigationTemplate = html `
    <template role="navigation">
        <ul class="list" part="list" ${ref("navContainer")}>
            ${repeat(x => x.data, navItemTemplate)}
        </ul>
        ${overflowTemplate}
        <div class="endContainer" part="endContainer">
            ${endTemplate}
        </div>
    </template>
`;
